import React from "react";
import * as theme from "../theme";
import { Button } from "react-bootstrap";

const SaveAndProceedButton = (props) => {
  const textSize = props.fontSize ? props.fontSize : "min(0.8vw, 15px)";
  const disabled = props.disabled ? props.disabled : false;
  return (
    <Button
      style={{
        display: props.display ?? "flex",
        width: "70%",
        height: "5vh",
        maxHeight: "6vmin",
        backgroundColor: theme.COLORS.group_tab_header_completed,
        borderRadius: 5,
        color: "white",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "GibsonRegular",
        fontSize: textSize,
        letterSpacing: 1,
        border: 0,
      }}
      onClick={props.onClick}
      disabled={disabled}
    >
      {props.text}
    </Button>
  );
};

export default SaveAndProceedButton;
